import { render } from "./Mobile.vue?vue&type=template&id=18b4c483&scoped=true"
import script from "./Mobile.vue?vue&type=script&lang=js"
export * from "./Mobile.vue?vue&type=script&lang=js"

import "./Mobile.vue?vue&type=style&index=0&id=18b4c483&lang=scss&scoped=true"

import exportComponent from "D:\\digitalnewspaper\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18b4c483"]])

export default __exports__